import i from './cart.container';

export default i;
